import React from 'react';
import { SignInDiv } from '../component/sign-in/SignInDiv';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { SignNavigationBar } from '../component/navigation-bar/SignNavigationBar';

export const SignInPage = () => (
  <SignInPageLayout
    navigationBar={<SignNavigationBar />}
    centerDesktop={<SignInDiv />}
  />
);
